import { PROJECT_MODEL_LIMIT } from 'src/constants/limits';
import {
  CLASS_IRIS,
  RDFS_SUB_CLASS_OF_IRI,
  SCHEMA_ORG_HTTP_SUPERSEDED_BY_IRI,
  SCHEMA_ORG_SUPERSEDED_BY_IRI,
} from 'src/templates/queries/iris';
import { BindingResult } from 'src/templates/queries/types';

export type ModelClassBindingResult = {
  subject?: BindingResult;
  parent?: BindingResult;
};

/**
 * Determines the classes with hierarchies for a given model.
 *
 * Used to snapshot the model information of a given reasoning schema.
 *
 * **Call Frequency**
 *
 * Called once when a model is added to a project.
 *
 * **Context**
 * - Named graphs: set by the user (default is `reasoning.schema.graphs` value,
 *   which by default is `tag:stardog:api:context:local`)
 * - Reasoning: always off
 *
 * **Example**
 * ```sparql
# Model Classes
SELECT DISTINCT ?subject ?parent
WHERE {
  VALUES ?class {
    <http://www.w3.org/2002/07/owl#Class>
    <http://www.w3.org/2004/02/skos/core#Concept>
    <http://www.w3.org/2000/01/rdf-schema#Class>
    <http://schema.org/Class>
  }
  ?subject a ?class
  OPTIONAL {
    ?subject <http://www.w3.org/2000/01/rdf-schema#subClassOf>
           | <https://schema.org/supersededBy>
           | <http://schema.org/supersededBy>
           ?parent
    FILTER (?subject != ?parent && isIRI(?parent))
  }
}
LIMIT 100000
 * ```
 */
export const modelClassesQuery = `# Model Classes
SELECT DISTINCT ?subject ?parent
WHERE {
  VALUES ?class {
    ${CLASS_IRIS.map((iri) => `<${iri}>`).join(' ')}
  }
  ?subject a ?class
  OPTIONAL {
    ?subject <${RDFS_SUB_CLASS_OF_IRI}>
           | <${SCHEMA_ORG_SUPERSEDED_BY_IRI}>
           | <${SCHEMA_ORG_HTTP_SUPERSEDED_BY_IRI}>
           ?parent
    FILTER (?subject != ?parent && isIRI(?parent))
  }
}
LIMIT ${PROJECT_MODEL_LIMIT}`;
